
import NavBar from './NavBar.vue';
import MainTemplate from './MainTemplate.vue';
import Loader from './Loader.vue';
import SideBar from './SideBar.vue';

export default {
    NavBar,
    MainTemplate,
    Loader,
    SideBar
}




// WEBPACK FOOTER //
// ./src/components/Admin/Components/index.js